/* eslint-disable */
class VideoPlayer {
  constructor(container) {
    this.container = container;
    this.video = container.querySelector('video, iframe');
    this.videoType = container.dataset.mediaType ? container.dataset.mediaType.toLowerCase() : '';
    this.playButton = container.querySelector('.media__video--btn');
    this.player = null;
    this.init();
  }
  init() {
    if (!this.video) return;
    switch (this.videoType) {
      case 'youtube':
        this.initYouTube();
        break;
      case 'vimeo':
        this.initVimeo();
        break;
      default:
        this.initHTML5Video();
    }
  }
  initYouTube() {
    // Load YouTube API if not already loaded
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      // Create a queue for players if it doesn't exist
      window.youTubeReadyQueue = window.youTubeReadyQueue || [];

      // Set up the API ready callback only once
      window.onYouTubeIframeAPIReady = () => {
        window.youTubeReadyQueue.forEach(callback => callback());
        window.youTubeReadyQueue = [];
      };
    }

    // Add this player's initialization to the queue
    const initPlayer = () => {
      this.player = new YT.Player(this.video, {
        events: {
          onStateChange: event => this.onYouTubeStateChange(event),
          onReady: () => {
            const playerElement = this.player.getIframe();
            const {
              width,
              height,
              offsetWidth,
              offsetHeight
            } = playerElement;
            this.setVideoSize('width', width || offsetWidth);
            this.setVideoSize('height', height || offsetHeight);
          }
        }
      });
    };
    if (window.YT && window.YT.Player) {
      initPlayer();
    } else {
      window.youTubeReadyQueue.push(initPlayer);
    }
  }
  initVimeo() {
    // Load Vimeo API if not already loaded
    if (!window.Vimeo) {
      const tag = document.createElement('script');
      tag.src = 'https://player.vimeo.com/api/player.js';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // Wait for the Vimeo API to be ready
    const initPlayer = () => {
      this.player = new Vimeo.Player(this.video);
      this.player.getVideoWidth().then(width => this.setVideoSize('width', width));
      this.player.getVideoHeight().then(height => this.setVideoSize('height', height));
      this.player.on('play', () => this.updatePlayButton(true));
      this.player.on('pause', () => this.updatePlayButton(false));
      this.player.on('ended', () => this.playButton.remove());
    };
    if (window.Vimeo && window.Vimeo.Player) {
      initPlayer();
    } else {
      // If Vimeo API is not ready, wait for it
      const checkVimeoReady = setInterval(() => {
        if (window.Vimeo && window.Vimeo.Player) {
          initPlayer();
          clearInterval(checkVimeoReady);
        }
      }, 100);
    }
  }
  initHTML5Video() {
    this.player = this.video;
    this.video.addEventListener('play', () => this.updatePlayButton(true));
    this.video.addEventListener('pause', () => this.updatePlayButton(false));
  }
  onYouTubeStateChange(event) {
    const isPlaying = event.data === YT.PlayerState.PLAYING;
    this.updatePlayButton(isPlaying);
  }
  updatePlayButton(isPlaying) {
    if (this.playButton) {
      this.container.classList.toggle('__playing', isPlaying);
      this.playButton.classList.toggle('is-playing', isPlaying);
      this.playButton.setAttribute('aria-label', isPlaying ? 'Pause' : 'Play');
    }
  }
  setVideoSize(name, value) {
    this.video.setAttribute(name, value);
    this.container.style.setProperty(`--${name}`, `${value}`);
  }
}
export default () => {
  const videoContainers = document.querySelectorAll('.media__video--wrap');
  videoContainers.forEach(container => {
    new VideoPlayer(container);
  });
};